import React, { useEffect, useState } from 'react';

// Utils
import { getTranslateByKey, isNullUndefined } from '@/main/services/utils';
import { SignalRReceiveUpdatesRequotePartResponse } from '@/main/models/common/signalRReceiveUpdatesResponse';
import { RequoteProcurementeProgressEnum } from '@/main/services/enum/RequoteProcurementeProgressEnum';
import * as S from './styles';
import { Step, StepLabel, StepLabelProps, Stepper } from '@mui/material';
import { SpinnerLoading } from '../styles';
import { useDispatch } from 'react-redux';
import { signalRClearReceiveUpdatesByKey } from '@/main/store/signalR';
import { SendUpdatesSignalRTypeEnum } from '@/main/services/enum/SendUpdatesSignalRTypeEnum';
import { toast } from 'react-toastify';
import { RoutesConstants } from '@/main/routes/routesConstants';
import { useNavigate } from 'react-router-dom';
import { getRefreshForceUrl } from '@/main/services/utilsQueryParams';
interface HubItemRequoteNationalPartProps {
  data: SignalRReceiveUpdatesRequotePartResponse[];
  customProps?: {
    onFinishedRequote: () => void;
    onErrorRequote: () => void;
  }
}

const HubItemRequotePart = ({ data, customProps }: HubItemRequoteNationalPartProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const formatteedData = isNullUndefined(data) ? [] : data;
  const [activeStep, setActiveStep] = useState(0);

  const hasErrorRequote = formatteedData.some(
    item => item.progressStatus === RequoteProcurementeProgressEnum.Error
  );
  const hasFinishedRequote = formatteedData.some(
    item => item.progressStatus === RequoteProcurementeProgressEnum.Finished
  );
  const stepsWithLabel = [
    {
      key: RequoteProcurementeProgressEnum.CreatingNewQuote,
      label: getTranslateByKey("requoteProcurement.creatingNewQuote"),
    },
    {
      key: RequoteProcurementeProgressEnum.SelectingSuppliers,
      label: getTranslateByKey("requoteProcurement.selectingSuppliers"),
    },
    {
      key: RequoteProcurementeProgressEnum.CancelingItems,
      label: getTranslateByKey("requoteProcurement.cancelingItems"),
    },
    {
      key: RequoteProcurementeProgressEnum.Finished,
      label: getTranslateByKey("requoteProcurement.finished"),
    }
  ];

  function getCustomIconProp(currentIndex: number): StepLabelProps {
    if (!hasFinishedRequote && !hasErrorRequote && currentIndex === activeStep) return { icon: <SpinnerLoading customSize='20px' /> }
    return {};
  }

  useEffect(() => {
    const lastItemRequoteSignalR = formatteedData[formatteedData.length - 1];
    if (isNullUndefined(lastItemRequoteSignalR)) {
      setActiveStep(0);
      return;

    };
    if (hasErrorRequote) {
      const findedStepError = formatteedData.find((item) => item.progressStatus === RequoteProcurementeProgressEnum.Error);
      const messageError = isNullUndefined(findedStepError) ? getTranslateByKey('information.somethingWrong', true) : findedStepError.message;
      toast.error(messageError, { autoClose: 10000 });
      if (!isNullUndefined(customProps?.onErrorRequote)) customProps.onErrorRequote();
      return
    }
    const findedIndexCurrent = stepsWithLabel.findIndex(
      item => item.key === lastItemRequoteSignalR.progressStatus
    );

    setActiveStep(findedIndexCurrent === -1 ? 0 : (findedIndexCurrent + 1));
    if (hasFinishedRequote) {
      if (!isNullUndefined(customProps?.onFinishedRequote)) customProps.onFinishedRequote();
      if (!isNullUndefined(lastItemRequoteSignalR.claimNumber)) {
        const filters = getRefreshForceUrl({
          quoteFilterVehicle: lastItemRequoteSignalR.claimNumber,
        })
        const routeRedirect = `${RoutesConstants.orderSearchOrder}${filters}`;
        navigate(routeRedirect);

      }
      dispatch(signalRClearReceiveUpdatesByKey(SendUpdatesSignalRTypeEnum.RequoteNational))
      return
    }
  }, [JSON.stringify(formatteedData)])


  return (
    <S.Container>
      <Stepper activeStep={activeStep} orientation="vertical">
        {stepsWithLabel.map((item, index) => (
          <Step key={`stepper-${index}`}>
            <StepLabel
              error={hasErrorRequote && index === activeStep}
              {...getCustomIconProp(index)}
            >
              {item.label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </S.Container>
  );
};

export default HubItemRequotePart;
